import { useEffect, useRef, useState } from "react";
import { PlaycanvasInformationMessages } from "../../assets/svg/PlaycanvasInformationMessages"
import s from "./InfoMessageInPlayer.module.scss"
import { onCameraStateChange } from "../../utils/functions/playcanvas/onCameraStateChange";
import { useSelector } from "react-redux";
import { getActiveEnvironmentId } from "../../redux/reducers/ui/uiSelectors";
export const InfoMessageInPlayer = () => {
    const [isCameraInside, setIsCameraInside] = useState(false);

    const activeEnvironmentId = useSelector(getActiveEnvironmentId())
    const prevEnvRef = useRef<number>(activeEnvironmentId)

    useEffect(() => {
        if (prevEnvRef.current !== activeEnvironmentId) {
            setIsCameraInside(true);
        }
        prevEnvRef.current = activeEnvironmentId
    }, [activeEnvironmentId])

    useEffect(() => {
        onCameraStateChange({ setIsCameraInside });
    }, []);

    if (!isCameraInside) {
        return (
            <div className={s.wrapper}>
                <div>Camera Is Out Of Bounds</div>
                <div className={s.icon}>
                    <PlaycanvasInformationMessages />
                </div>
            </div>)

    }
    return null;
}
